<template>
  <div class="Tph-Hint">
    <InfoIcon class="Tph-Hint__icon"/>
    <span class="Tph-Hint__txt"><slot /></span>
  </div>
</template>

<script setup>
  //#TypographyHint
  //---------------------------------
  import InfoIcon from '@shared/UI/SVG/InfoIcon.vue';
</script>

<style lang="scss">
  @import './styles/_conf';
</style>